module.exports = __webpack_public_path__ + "static/media/1.ab1f16e.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/majors/1.wav
// module id = 5x/k
// module chunks = 0